// @flow
import React from "react"
import { CheckboxWrap } from "./styled"
import CheckIcon from "./CheckIcon"

type Props = {|
  value: ?boolean,
  onClick?: Function,
  big?: boolean,
|}

const Checkbox = ({ value, onClick, big }: Props) => (
  <CheckboxWrap onClick={onClick} checked={!!value} big={big}>
    {value && <CheckIcon />}
  </CheckboxWrap>
)

export default Checkbox



// WEBPACK FOOTER //
// ./src/components/Checkbox/index.js